<div class="flex w-[640px] flex-col gap-4">
	<div class="font-body text-base font-bold text-on-background-alt">Que souhaites-tu faire maintenant ?</div>
	<ul class="uikit-list list-divide">
		<li
			class="uikit-card-item item-default item-hover ay-card-item cursor-pointer py-4"
			(click)="goToCreateOrdo()"
		>
			<span class="flex-1 font-display text-sm font-bold">Saisir une ordonnance</span>
			<span>
				<uikit-button
					type="tonal"
					size="small"
					icon="file-heart"
				></uikit-button>
			</span>
		</li>
		<li
			class="uikit-card-item item-default item-hover ay-card-item cursor-pointer py-4"
			(click)="goToCompleteDossierPatient()"
		>
			<span class="flex-1 font-display text-sm font-bold">Compléter son dossier patient</span>
			<span>
				<uikit-button
					type="tonal"
					size="small"
					icon="user-exclamation"
				></uikit-button>
			</span>
		</li>
		<li
			class="uikit-card-item item-default item-hover ay-card-item cursor-pointer py-4"
			(click)="close()"
		>
			<span class="flex-1 font-display text-sm font-bold">Terminer</span>
			<span>
				<uikit-button
					type="tonal"
					size="small"
					icon="user-exclamation"
				></uikit-button>
			</span>
		</li>
	</ul>
</div>
